<script>
    // import MediumEditor from 'medium-editor'
    import { onMount } from "svelte";
    //  import MediumEditorTable from  '../Services/medium-editor-tables'
    let editor;
    export let name="empty"
    export let data = "";
    export let placeholder = "Enter the information here. If you need to work it out, then click on the blue text (here) and start typing"
    onMount(() => {


        editor = new MediumEditor("."+name, {
            placeholder: {
                /* This example includes the default options for placeholder,
         if nothing is passed this is what it used */
                text:
                    placeholder,
                hideOnClick: true,
            },
            toolbar: {
                buttons: [
                    
                    "bold",
                    "italic",
                    "underline",
                    "strikethrough",
                    "subscript",
                    "superscript",
                    "anchor",
                    "quote",
                    "orderedlist",
                    "unorderedlist",
                    "indent",
                    "outdent",
                    "justifyLeft",
                    "justifyCenter",
                    "justifyRight",
                    "justifyFull",
                    "h1",
                    "h2",
                    "h3",
                    "table",
                    'image',
                    'html',
                    'removeFormat'
                ],

                diffLeft: 25,
                diffTop: 10,
            },
            paste:{
                forcePlainText:false
            },
            extensions: {
                table: new MediumEditorTable(),
               
               
            },
        });

        editor.subscribe("blur", function(x) {
            const editorHtml = editor.getContent()
            //contentNoButtons = $(`<div>${editorHtml}</div>`).find('.medium-insert-buttons').remove().end();
            data=editorHtml//contentNoButtons.html()
        })

        content(data)
    });

    

    const content = (data) => {
        if (editor) 
            editor.setContent(data);
    };

    $: content(data);
</script> 

<div class="{name}" />

 